import { notesPendingActionActions, userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
};

export const reducer = createReducer(initialState, {
    [notesPendingActionActions.loadSuccess]: (state, action) => {
        return action.payload.entities.notesPendingActionMsgs;
    },
    [userActions.loadSessionSuccess]: (state, action) => {
        let result;
        action.payload.notesPendingAction.entities.notesPendingActionMsgs ? result = action.payload.notesPendingAction.entities.notesPendingActionMsgs : result = {};
        return result;
    },
    [notesPendingActionActions.deleteSuccess]: (state, action) => {
        return Object.values(state).forEach(x => {
            if (x.noteId === action.payload.noteId) {
                delete state[x.id];
            }
        })
    },

})


